<kendo-panelbar>
    <kendo-panelbar-item title="HCPOA Agent" [expanded]="panelBarExpanded">
        <ng-template kendoPanelBarContent>
            <div [formGroup]="formGroup" [style.padding.px]="10">
                <p class="sub-header">Note: If you are publishing HCPOA please fill out the required fields.</p>
                <p>Agent: </p>
                <div class="row-wrap" [style.gap.px]="10" [style.margin-bottom.px]="10">
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="First Name *">
                            <kendo-textbox formControlName="dm_fname"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="Last Name *">
                            <kendo-textbox formControlName="dm_lname"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="Phone">
                            <kendo-maskedtextbox [mask]="phoneMask" formControlName="dm_phone"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
                <p>Alternate Agent: </p>
                <div class="row-wrap" [style.gap.px]="10">
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="First Name">
                            <kendo-textbox formControlName="alt_dm_fname"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="Last Name">
                            <kendo-textbox formControlName="alt_dm_lname"></kendo-textbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                    <kendo-formfield [style.max-width.px]="200">
                        <kendo-floatinglabel text="Phone">
                            <kendo-maskedtextbox [mask]="phoneMask" formControlName="alt_dm_phone"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                    </kendo-formfield>
                </div>
            </div>
        </ng-template>
    </kendo-panelbar-item>
</kendo-panelbar>

